import type { Job } from "../../shared/api.js";
import { h } from "../dom.js";
import { amount, stackDetail, stackName, time } from "../format.js";
import { stackIcon } from "./StackIcon.js";

export function jobTable(jobs: Job[], empty: string): HTMLElement {
  if (!jobs.length) return h("p", { class: "muted empty" }, empty);
  return h(
    "div",
    { class: "table-wrap" },
    h(
      "table",
      null,
      h("thead", null, h("tr", null, h("th", null, "When"), h("th", null, "Stack"), h("th", { class: "num" }, "Amount"), h("th", null, "CPU"), h("th", null, "State"), h("th", null, "From"))),
      h(
        "tbody",
        null,
        ...jobs.map((job) =>
          h(
            "tr",
            { key: job.id },
            h("td", { class: "small" }, time(job.updatedAt)),
            h("td", null, h("div", { class: "stack-name" }, stackIcon(job.stack), stackName(job.stack)), h("div", { class: "muted small" }, stackDetail(job.stack))),
            h("td", { class: "num" }, amount(job.amount, job.stack.type)),
            h("td", null, job.cpu ?? "any"),
            h("td", null, h("span", { class: `badge job-${job.state}` }, job.state), job.reason ? h("div", { class: "muted small" }, job.reason) : null),
            h("td", { class: "small" }, job.origin),
          ),
        ),
      ),
    ),
  );
}
